import { JsonObject, JsonProperty } from 'json2typescript';

import { FundTransfer } from './fund-transfer';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { TransferInterface } from '../../../core';

@JsonObject('Transfer')
export class Transfer implements TransferInterface {
    @JsonProperty('PortfolioCode', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('TransferBankAmount', Number, true)
    private _amount: number = undefined;

    @JsonProperty('FundTransfers', [FundTransfer], true)
    private _fundTransfers: FundTransfer[] = [];

    @JsonProperty('TransferBankName', String, true)
    private _transferBankName: string = undefined;

    constructor(code?: Id) {
        this._code = code;
        this._amount = 0;
    }

    get code(): Id {
        return this._code;
    }

    set code(value: Id) {
        this._code = value;
    }

    get amount(): number {
        return this._amount;
    }

    set amount(value: number) {
        this._amount = value;
    }

    get fundTransfers(): FundTransfer[] {
        if (!this._fundTransfers) {
            this._fundTransfers = [];
        }

        return this._fundTransfers;
    }

    get total(): number {
        return this.amount + this.fundTransfers.map((fundTransfer) => fundTransfer.amount).reduce((prev, curr) => prev + curr, 0);
    }

    get transferBankName(): string {
        return this._transferBankName;
    }

    set transferBankName(value: string) {
        this._transferBankName = value;
    }

    addTransfer(value: FundTransfer) {
        if (!this._fundTransfers.find((it) => String(it.id) === String(value.id))) {
            this.fundTransfers.push(value);
        } else {
            this.updateTransfer(value);
        }
    }

    private updateTransfer(value: FundTransfer) {
        this.fundTransfers.map((it, idx) => {
            if (String(it.id) === String(value.id)) {
                this.fundTransfers[idx] = value;
            }
        });
    }

    removeTransfer(value: FundTransfer) {
        this.fundTransfers.map((it, idx) => {
            if (String(it.id) === String(value.id)) {
                this.fundTransfers.splice(idx, 1);
            }
        });
    }

    isComplete(min: number = 0): boolean {
        return !!this.code && this.total >= min;
    }
}
